import { useState, useEffect } from 'react';
import { Star } from 'lucide-react';
import { fetchReviewsForTarget, calculateReviewStats } from '../../services/reviewService';

export default function InstructorReviewBadge({ instructorId, className = "" }) {
  const [stats, setStats] = useState({ average: 0, total: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    
    const loadStats = async () => {
      try {
        const reviews = await fetchReviewsForTarget(instructorId);
        const calcStats = calculateReviewStats(reviews);
        if (isMounted) {
          setStats(calcStats);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error loading instructor reviews:", error);
        if (isMounted) setLoading(false);
      }
    };

    if (instructorId) {
      loadStats();
    } else {
      setLoading(false);
    }

    return () => { isMounted = false; };
  }, [instructorId]);

  if (loading) {
    return (
      <div className={`flex items-center gap-1.5 animate-pulse ${className}`}>
        <div className="w-4 h-4 rounded bg-amber-200 dark:bg-amber-500/20"></div>
        <div className="h-4 w-12 bg-slate-200 dark:bg-white/10 rounded"></div>
      </div>
    );
  }

  if (stats.total === 0) {
    return (
      <div className={`flex items-center gap-1.5 text-slate-400 dark:text-zinc-500 font-medium ${className}`} title="لم يقيم بعد">
        <Star className="w-4 h-4" />
        <span className="text-sm">لم يُقيم</span>
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <Star className="w-4 h-4 text-amber-500" fill="currentColor" />
      <span className="font-bold text-slate-700 dark:text-white">{stats.average.toFixed(1)}</span>
      <span className="text-slate-400 dark:text-zinc-500 text-sm font-medium">({stats.total})</span>
    </div>
  );
}
